import { useMemo } from 'react';

import { APOLLO_STATE_PROP_NAME, initializeApollo } from '@/graphql/client';

// prettier-ignore
export function useApollo(pageProps: Record<string, any>) {  //NOSONAR
  const state = pageProps[APOLLO_STATE_PROP_NAME];
  return useMemo(() => initializeApollo(state), [state]);
}
